/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeAccessTypeDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { LanguageDto } from '../models';
// @ts-ignore
import type { TeamActivitiesResultDto } from '../models';
/**
 * TeamDevelopmentActivitiesApi - axios parameter creator
 * @export
 */
export const TeamDevelopmentActivitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Źródło filtra \"Aktywności rozwojowe\" na liście podległego obszaru. Zwraca wyłącznie te aktywności, które ktoś z zakresu wołającego faktycznie ma — dzięki temu wybór z listy nigdy nie prowadzi do pustego wyniku. Pozycje są scalone po edycjach: \"CCL\" z 2019 i z 2025 to jedna wartość, dokładnie tak, jak dopasowuje ją filtr listy pracowników. 
         * @summary Development activities available as a filter value (JAIN-261)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTeamDevelopmentActivities: async (accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/team/development/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accessType !== undefined) {
                localVarQueryParameter['accessType'] = accessType;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamDevelopmentActivitiesApi - functional programming interface
 * @export
 */
export const TeamDevelopmentActivitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamDevelopmentActivitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * Źródło filtra \"Aktywności rozwojowe\" na liście podległego obszaru. Zwraca wyłącznie te aktywności, które ktoś z zakresu wołającego faktycznie ma — dzięki temu wybór z listy nigdy nie prowadzi do pustego wyniku. Pozycje są scalone po edycjach: \"CCL\" z 2019 i z 2025 to jedna wartość, dokładnie tak, jak dopasowuje ją filtr listy pracowników. 
         * @summary Development activities available as a filter value (JAIN-261)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readTeamDevelopmentActivities(accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamActivitiesResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readTeamDevelopmentActivities(accessType, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamDevelopmentActivitiesApi.readTeamDevelopmentActivities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamDevelopmentActivitiesApi - factory interface
 * @export
 */
export const TeamDevelopmentActivitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamDevelopmentActivitiesApiFp(configuration)
    return {
        /**
         * Źródło filtra \"Aktywności rozwojowe\" na liście podległego obszaru. Zwraca wyłącznie te aktywności, które ktoś z zakresu wołającego faktycznie ma — dzięki temu wybór z listy nigdy nie prowadzi do pustego wyniku. Pozycje są scalone po edycjach: \"CCL\" z 2019 i z 2025 to jedna wartość, dokładnie tak, jak dopasowuje ją filtr listy pracowników. 
         * @summary Development activities available as a filter value (JAIN-261)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readTeamDevelopmentActivities(accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<TeamActivitiesResultDto> {
            return localVarFp.readTeamDevelopmentActivities(accessType, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamDevelopmentActivitiesApi - interface
 * @export
 * @interface TeamDevelopmentActivitiesApi
 */
export interface TeamDevelopmentActivitiesApiInterface {
    /**
     * Źródło filtra \"Aktywności rozwojowe\" na liście podległego obszaru. Zwraca wyłącznie te aktywności, które ktoś z zakresu wołającego faktycznie ma — dzięki temu wybór z listy nigdy nie prowadzi do pustego wyniku. Pozycje są scalone po edycjach: \"CCL\" z 2019 i z 2025 to jedna wartość, dokładnie tak, jak dopasowuje ją filtr listy pracowników. 
     * @summary Development activities available as a filter value (JAIN-261)
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamDevelopmentActivitiesApiInterface
     */
    readTeamDevelopmentActivities(accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<TeamActivitiesResultDto>;

}

/**
 * TeamDevelopmentActivitiesApi - object-oriented interface
 * @export
 * @class TeamDevelopmentActivitiesApi
 * @extends {BaseAPI}
 */
export class TeamDevelopmentActivitiesApi extends BaseAPI implements TeamDevelopmentActivitiesApiInterface {
    /**
     * Źródło filtra \"Aktywności rozwojowe\" na liście podległego obszaru. Zwraca wyłącznie te aktywności, które ktoś z zakresu wołającego faktycznie ma — dzięki temu wybór z listy nigdy nie prowadzi do pustego wyniku. Pozycje są scalone po edycjach: \"CCL\" z 2019 i z 2025 to jedna wartość, dokładnie tak, jak dopasowuje ją filtr listy pracowników. 
     * @summary Development activities available as a filter value (JAIN-261)
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamDevelopmentActivitiesApi
     */
    public readTeamDevelopmentActivities(accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return TeamDevelopmentActivitiesApiFp(this.configuration).readTeamDevelopmentActivities(accessType, lang, options).then((request) => request(this.axios, this.basePath));
    }
}

